import axios from "../axios";
import { getLangPath } from "../i18n/getLang";
import store from "../local/cart";
const lang = getLangPath();
// 登录、注册、验证
export default {
  data() {
    return {
      // 邮箱格式是否正确
      mailCorrect: false,
    };
  },
  methods: {
    // 登录
    userLogin() {
      if (this.login.email === "" || this.login.email.trim() === "") {
        this.$message.error(this.$t("login.emailMessage"));
        return false;
      } else if (
        this.login.password === "" ||
        this.login.password.trim() === ""
      ) {
        this.$message.error(this.$t("login.passwdMessage"));
        return false;
      } else {
        this.login_loading = true;
        this.$json
          .post("login", {
            email: this.login.email,
            password: this.login.password,
            remember: ~~this.login.remember || 0,
          })
          .then((res) => {
            window.sessionStorage.removeItem("userInfo");
            store.commit("DEL_ALL_CHECKED");
            // 获取收藏商品数据
            store.dispatch("GET_FAVORITE_LIST");
            // 如果本地保存的购物车不为空
            if (Object.values(store.state.cartList).length) {
              store.dispatch("POST_CART", lang);
            } else {
              window.location.href = `/${lang}`;
            }
          })
          .catch((error) => {
            this.login_loading = false;
          });
      }
    },
    // 忘记密码
    forget() {
      if (this.forgetMail === "" || this.forgetMail.trim() === "") {
        this.$message.error(this._t("login.emailMessage"));
        return false;
      } else {
        this.$json
          .get("/reset_password_email", {
            params: {
              email: this.forgetMail,
            },
          })
          .then((res) => {
            this.$message.success(res.msg);
            setTimeout(() => {
              window.location.href = `/${lang}login`;
            }, 2000);
          })
          .catch((res) => {});
        return true;
      }
    },

    // 注册
    userRegister() {
      if (!this.agreeReg) {
        this.$message.error(this.$t("login.check"));
      } else {
        // login 弹框
        this.register_loading = true;
        this.$json
          .get("register_email", { params: this.register })
          .then((res) => {
            this.loginDialogVisible = false;
            this.register_loading = false;
            this.$message({
              message: res.msg,
              type: "success",
            });
          })
          .catch((res) => {
            this.register_loading = false;
          });
      }
    },
    // 邮箱验证
    mailValidator() {
      var reg = /^([a-zA-Z0-9]+[_\-\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_\-\.]?)*\.[a-zA-Z]{2,3}$/;
      let regdiv = document.getElementById("regmail");
      let i = regdiv.getElementsByTagName("i")[0].classList;
      let span = regdiv.getElementsByTagName("span")[0];
      if (reg.test(this.register.email)) {
        this.mailCorrect = false;
        regdiv.classList.add("checked");
        regdiv.classList.remove("error");
        i.add("el-icon-circle-check");
        i.remove("el-icon-warning");
        // span.innerText = '';
      } else {
        // 邮箱格式不正确
        this.mailCorrect = true;
        regdiv.classList.add("error");
        regdiv.classList.remove("checked");
        i.add("el-icon-warning");
        i.remove("el-icon-circle-check");
        // span.innerText = '邮箱格式不正确';
      }
    },
    open() {
      this.mailCorrect = false;
      this.register.email = "";
      this.agreeReg = false;
      this.login.mail = "";
      this.login.password = "";
    },
    close() {
      if (document.getElementsByClassName("mail-icon")[0])
        document.getElementsByClassName("mail-icon")[0].classList = [];

      if (document.getElementById("regmail"))
        document.getElementById("regmail").classList = [];
      // document.getElementById('text').innerText = '';
    },
  },
};



// WEBPACK FOOTER //
// ./resources/js/lib/mixins/validator.js